export const appDataSelector = state => state.appData;

export const alertListSelector = state => state.appData.alertList;

export const alertFirstSelector = state => (state.appData.alertList.length > 0 ? state.appData.alertList[0] : null);

export const alertSelector = (state, id) => state.appData.alertList.find(alert => alert.id === id);